import { ID } from '@/types/common'
import { DAILY_SEQUENCE_COLORS, CLASS_TYPE_LABEL } from './constants'
import { BillingMode, ClassType, GenerateClassRecordTemplate } from './types'

export const idKey = (id: ID) => String(id)

export const getDailySequenceColor = (sequence: number): string => {
  const index = Math.max(sequence, 1) - 1
  return DAILY_SEQUENCE_COLORS[index % DAILY_SEQUENCE_COLORS.length]
}

export const getUnifiedMonthlyPrice = (
  templates: Array<
    Pick<GenerateClassRecordTemplate, 'billingMode' | 'coursePrice'>
  >,
) => {
  const monthlyPrices = templates
    .filter((template) => template.billingMode === BillingMode.MONTHLY)
    .map((template) => template.coursePrice)
    .filter((price): price is number => price !== undefined && price !== null)

  if (monthlyPrices.length < 2) {
    return null
  }

  return monthlyPrices.every((price) => price === monthlyPrices[0])
    ? monthlyPrices[0]
    : null
}

export const getTemplatePriceText = (
  billingMode: BillingMode,
  coursePrice?: number | null,
  fallbackMonthlyPrice?: number | null,
  unifiedMonthlyPrice?: number | null,
) => {
  if (billingMode === BillingMode.GIFT) {
    return '赠课'
  }
  if (billingMode === BillingMode.ALL_DAY) {
    const fee = unifiedMonthlyPrice ?? fallbackMonthlyPrice
    return fee !== undefined && fee !== null
      ? `全天班+全天班费用${fee}`
      : '全天班+全天班费用未设'
  }
  if (billingMode === BillingMode.MONTHLY) {
    if (
      unifiedMonthlyPrice !== undefined &&
      unifiedMonthlyPrice !== null &&
      coursePrice === unifiedMonthlyPrice
    ) {
      return `统一月费${unifiedMonthlyPrice}`
    }
    if (coursePrice !== undefined && coursePrice !== null) {
      return `月费${coursePrice}`
    }
    return fallbackMonthlyPrice !== undefined && fallbackMonthlyPrice !== null
      ? `统一月费${fallbackMonthlyPrice}`
      : '月费未设'
  }
  return coursePrice ?? '-'
}

export const getRecordConfigText = (
  sessionLabel: string,
  classType: ClassType,
  teacherName: string | null | undefined,
  billingMode: BillingMode,
  coursePrice: number | null | undefined,
  fallbackMonthlyPrice?: number | null,
  unifiedMonthlyPrice?: number | null,
) =>
  `${sessionLabel} / ${CLASS_TYPE_LABEL[classType] || classType} / ${teacherName || '-'} / ${getTemplatePriceText(
    billingMode,
    coursePrice,
    fallbackMonthlyPrice,
    unifiedMonthlyPrice,
  )}`
